
  $(document).ready(function() {
    apiproducts()
  })
  document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    apiproducts()
  });
  document.addEventListener('ShoptetPageSortingChanged', function() {
    apiproducts();
  });
  document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    apiproducts();
  });


function apiproducts(){
  var apiUrl = "https://friends.shopcode.cz/api-code.php";
  var section = "mikemoda";
  var productsCodes = [];
  $('.products-block .product').each(function() {
    var sku = $(this).find('span[data-micro="sku"]').text().trim();
    if (sku) {
      productsCodes.push(sku);
    }
  });
  $.ajax({
    url: apiUrl,
    type: "GET",
    data: {
      section: section,
      codes: productsCodes.join(",")
    },
    dataType: "json",
    success: function(response) {
      $.each(response, function(index, group) {
        if ((!group.friend || group.friend === "") && (!group.colors || group.colors.length === 0)) {
          return;
        }
        var $productEl = $('.products-block .product').filter(function() {
          return $(this).find('span[data-micro="sku"]').text().trim() === group.code;
        });
        if ($productEl.length) {
          $productEl.addClass('product-has-colors');
          var totalColors = group.colors.length;
          var visibleCount = 5;
          var addColor = '';
          for (var i = 0; i < totalColors; i++) {
            if (i < visibleCount) {
              var color = group.colors[i];
              addColor += "<li><a href='" + color.url + "'>" +
                "<img src='" + color.BARVA_URL + "' alt='" + color.BARVA + "' /></a></li>";
            }
          }
          var remain = totalColors - visibleCount;
          if (remain > 0) {
            var sklonovani = sklonujDalsi(remain);
            addColor += "<li class='remain-arrow'><a href='"+$productEl.find('a.image').attr('href')+"'><span>+ " + remain + " "+sklonovani+"</span></a></li>";
          }
          
          if(!$productEl.find('.colorVariants').length){
            $productEl.find('.p-in').append(
              '<div class="colorVariants">' +
                '<span>Barevné varianty:</span>' +
                '<ul>' + addColor + '</ul>' +
              '</div>'
            );
          }
        }
      });
    },
    error: function(xhr, status, error) {
      console.error("Chyba při volání API:", error);
    }
    });
}
  

function sklonujDalsi(pocet) {
  var mod100 = pocet % 100;
  var mod10 = pocet % 10;
  if (mod100 >= 11 && mod100 <= 14) {
    return "dalších";
  }
  if (mod10 === 1) {
    return "další";
  }
  if (mod10 >= 2 && mod10 <= 4) {
    return "další";
  }
  return "dalších";
}

